import statusValues from '@modules/UserStatusModule/statusValues';
import UserStatusText from './UserStatusText';
import { Stack } from '@servicetitan/design-system';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';

type UserStatusDisplayProps = {
  status: UserSetAvailabilityStatus | 'WRAP_UP'; // to include automated queue recovery status "WRAP_UP"
  recoveryTimeInSeconds: number;
};

const UserStatusDisplay = ({
  status,
  recoveryTimeInSeconds,
}: UserStatusDisplayProps) => {
  const minutes = Math.floor(recoveryTimeInSeconds / 60);
  const seconds = Math.floor(recoveryTimeInSeconds % 60);

  // Format minutes and seconds
  const formattedMinutes = minutes;
  const formattedSeconds = seconds.toString().padStart(2, '0');

  // Concatenate minutes and seconds with a colon
  const formattedTime = `${formattedMinutes}:${formattedSeconds}`;

  const text = statusValues[status] || 'Unknown';

  return (
    <Stack>
      <UserStatusText text={text} />
      {!!recoveryTimeInSeconds && <UserStatusText text={formattedTime} bold />}
    </Stack>
  );
};

export default UserStatusDisplay;
